export const NOT_INSTALLED = "MetaMask not installed";
export const MISSING_PROVIDER = "Missing provider";
export const LOCKED = "MetaMask is locked";
export const TIMEOUT = "Timeout";
